<template>
  <div class="ag-page_alertcs position-relative">
    <ag-card :module="module"></ag-card>
  </div>
</template>

<script>
import { defineAsyncComponent, defineComponent, ref } from "vue";
import AgCard from "@/components/ag-card/index.vue";
import GroupList from "@/helpers/pages/GroupList";
import { useStore } from "@/store";
import { GeneralActionTypes } from "@/store/modules/general/action-types";
import { useRoute } from "vue-router";

export default defineComponent({
  name: "GroupList",
  setup() {
    const route = useRoute();
    const module = ref(GroupList);
    const breadcrumbComponent = defineAsyncComponent(() =>
      import("@/views/pages/Assets/AssetBreadcrumb.vue")
    );
    const store = useStore();
    const setFilterStatus = () => {
      store.dispatch(GeneralActionTypes.FILTER_STATUS, false);
    };
    let filter = ref({
      page: 1,
      limit: 10,
      sortColumn: "",
      sortDir: "",
    });

    const RESETFILTER = filter;
    const getList = async (
      filters = filter.value,
      options = module.value.component.options
    ) => {
      filters.guid = route.params.siteGuid;
      const body = { filters, options };
      await store.dispatch(GeneralActionTypes.GET_ASSET_GROUPS, body);
      options.allRows = options.rows;
    };

    const searchWithFilters = (param) => {
      filter.value.page = module.value.component.options.page || 0;
      filter.value.limit = module.value.component.options.pageSize || 5;
      filter.value.sortColumn = "";
      filter.value.sortDir = "";

      const filters = filter.value;
      const options = module.value.component.options;
      module.value.readyToUseFilters = filters;
      getList(filters, options);
    };

    const resetFilters = () => {
      searchWithFilters(true);
    };

    return {
      setFilterStatus,
      searchWithFilters,
      resetFilters,
      filter,
      getList,
      module,
      breadcrumbComponent,
    };
  },
  mounted() {
    this.setFilterStatus();
    const filters = this.filter;
    this.module.readyToUseFilters = filters;
    const options = this.module.component.options;
    this.getList(filters, options);
  },
  components: { AgCard },
});
</script>

<style>
.ag-card_buttons {
  align-items: center;
}
.ag-card_buttons .ag-button {
  height: 37px;
  background: #164b6c;
}
</style>